import React, { Suspense } from "react";
import { Box } from "@mui/material";
import { Outlet } from "react-router-dom";
import Header from "./Header2";
import Footer from "./Footer2";
import { CircleLoading } from "components/loaders/Loaders";
import { useLanguage } from "context/UseContext";

function WebLayout() {
  const { lang } = useLanguage();

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        minHeight: "100vh",
        overflowX: "hidden",
      }}
      dir={lang === "ar" ? "rtl" : "ltr"}
    >
      {/* ========== Header ========== */}
      <Header />

      {/* ========== Main ========== */}
      <Box component="main" flexGrow={1}>
        <Suspense fallback={<CircleLoading />}>
          <Outlet />
        </Suspense>
      </Box>

      {/* ========== Footer ========== */}
      <Footer />
    </Box>
  );
}

export default WebLayout;
